import { Concierge } from 'app/types/@twilio/conversations';
import { CONCIERGE_KEY } from 'app/modules/live-chat/hooks/useConcierge';
import { TwilioMessage } from '@twilio/conversations';

import queryClient from '../queryClient';

function getConciergeKey() {
  const conditionId = window.ostro.conditionId;
  return `ostroConcierge-${conditionId}`;
}

const defaultConcierge: Concierge = {
  avatar: '',
  name: '',
};

export function isConcierge(message: TwilioMessage): boolean {
  return message.attributes?.type === 'nurse_profile_info_v2';
}

export function findLastConcierge(messages: TwilioMessage[]) {
  const message = [...messages].reverse().find(isConcierge);

  if (message) {
    return message.attributes?.concierge;
  }
}

export function getConcierge(): Concierge {
  const json = localStorage.getItem(getConciergeKey());

  if (json) {
    return JSON.parse(json);
  }

  return defaultConcierge;
}

export function conciergeJoined() {
  const concierge = getConcierge();

  return Boolean(concierge.avatar && concierge.name);
}

export async function setConcierge(concierge?: Concierge) {
  if (!concierge) return;

  localStorage.setItem(getConciergeKey(), JSON.stringify(concierge));
  queryClient.setQueryData(CONCIERGE_KEY, concierge);
}
